const localizations = {
  'de-DE': require('./data/l10n/de-DE'),
  'en-US': require('./data/l10n/en-US'),
}

const langcode = {
  'en-US':  'en-US',
  'de-DE':  'de-DE'
}

const defaultlang = 'de-DE'
const default_autocomplete_lang = ['de-DE','en-US']

function l10n(lang, text) {
  lang = langcode[lang] || defaultlang
  return (localizations[lang] && localizations[lang][text])
    ? localizations[lang][text]
    : (localizations[defaultlang] && localizations[defaultlang][text])
      ? localizations[defaultlang][text]
      : text
}

let lang = defaultlang

module.exports = {
  defaultlang,
  default_autocomplete_lang,
  langcode,
  get lang() {return lang},
  set lang(newlang) {lang = langcode[newlang]},
  localizations,
  _l10n: l10n, /* semi-private variant that doesn't set lang from global `lang` */
  l10n(text) {return l10n(lang, text)},
}



//////////////////
// WEBPACK FOOTER
// ./js/PortalL10n.js
// module id = 3
// module chunks = 0